export const projectStatus = () => {
  const taskButton = document.querySelector(".js-project-status");
  const statusModal = document.querySelector(".js-status-modal");

  function openStatusModal(event) {
    statusModal.classList.add("modal--show");
  };

  if (taskButton) {
    taskButton.addEventListener('click', openStatusModal);
  }
}
